// extracted by mini-css-extract-plugin
module.exports = {"counts":"SpvAdminFinances_counts__312A4","controls":"SpvAdminFinances_controls__27a7q"};